import React from 'react'
import { connect } from 'react-redux'
import SideDirectory from 'components/landing/SideDirectory'
import LeaveMessage from 'components/landing/LeaveMessage'
import Hero from 'components/hero/Hero'
import Feature from 'components/landing/Feature'
import Pricing from 'components/landing/Pricing'
import Footer from 'components/footer/Footer'
import {Helmet} from 'react-helmet'
import {
  isIE
} from "react-device-detect"

const Home = props => (
  <div style={{position: 'relative'}}>
    <Helmet>
        <title>Welcome to OwlGo</title>
    </Helmet>
    <SideDirectory />
   {/* {!isIE ? <LeaveMessage /> : null}*/}
    <span className="anchor" id="top"/>
    <Hero />
    <span className="anchor" id="features"/>
    <Feature />
    {/*<Pricing />*/}
    <span className="anchor" id="footer"/>
    <Footer />
  </div>
)

const mapStateToProps = ( state, props ) => ({
    routerHash: state.router.location.hash,
})

const mapDispatchToProps ={

    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)



// WEBPACK FOOTER //
// ./src/croutes/home/index.js